import { useEffect, useRef, useState } from 'react'
import { Calendar } from 'react-date-range'
import format from 'date-fns/format'
import './default.scss'
import './style.scss'
import moment from 'moment'
import { getNextTwoBusinessDays } from '../../../components/utils'

const SingleCalenderComp = (props) => {
    const [open, setOpen] = useState(false)
    const refOne = useRef(null)
    const handleSelect = (e) => {
        const newDate = new Date(e)
        if (refOne.current) {
            const openValue = props?.alwaysOpen ? props?.alwaysOpen : false
            setOpen(openValue)
            props.closeTheCalender()
        }
        props.selectedDate(newDate)
    }

    const hideOnEscape = (e) => {
        if (e.key === 'Escape') {
            const openValue = props?.alwaysOpen ? props?.alwaysOpen : false
            setOpen(openValue)
            props.closeTheCalender()
        }
    }

    const hideOnClickOutside = (e) => {
        if (refOne.current && !refOne.current.contains(e.target)) {
            props.closeTheCalender()
            const openValue = props?.alwaysOpen ? props?.alwaysOpen : false
            setOpen(openValue)
        }
    }
    useEffect(() => {
        if (props.openCalender) {
            setOpen(true)
        }
    }, [props.openCalender])

    useEffect(() => {
        document.addEventListener('keydown', hideOnEscape, true)
        document.addEventListener('click', hideOnClickOutside, true)
        return () => {
            document.removeEventListener('keydown', hideOnEscape, true)
            document.removeEventListener('click', hideOnClickOutside, true)
        }
    }, [props.displayDate])
    // function toPST(dateInput) {
    //     // If input is a Moment object, convert to JS Date
    //     const date = moment.isMoment(dateInput) ? dateInput.toDate() : new Date(dateInput);

    //     // Convert to PST
    //     return new Date(
    //         date.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    //     );
    // }
    // Get minDate = two business days from now
    const minBusinessDate = getNextTwoBusinessDays(moment(), 3).toDate();

    return (
        <div className="calenderwrapper">
            <div ref={refOne}>
                {open && (
                    <Calendar
                        minDate={minBusinessDate}
                        maxDate={props?.maxDate ? props?.maxDate : undefined}
                        date={new Date(props.displayDate)}
                        onChange={handleSelect}
                        className="calendarElement"
                        // value={new Date()}
                        disabledDay={(date) => {
                            const day = date.getDay();
                            return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
                          }}
                    />
                )}
            </div>
        </div>
    )
}

export default SingleCalenderComp
